import { Routes, RouterModule } from '@angular/router';
import { BlogComponent } from './blog/blog.component';
import { HomeOneComponent } from './home/versions/home-one/home-one.component';
/*PJMA: Aquí se cambía la ruta del inicio*/
export const rootRouterConfig: Routes = [
  {
    path: '',
    redirectTo: '/home/one',
    pathMatch: 'full'
  },
  {
    path: 'one',
    component: HomeOneComponent
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'blog',
    component: BlogComponent,
    loadChildren: () => import('./blog/blog.module').then(m => m.BlogModule)
  },
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule)
  },
  {
    path: '**',
    redirectTo: 'home/one'
  }
];

